import type { InputProps } from "react-aria-components";

import React from "react";
import { Group } from "react-aria-components";

import { Button } from "@/components/button";
import { Input } from "@/components/field";
import { EmailIcon, XIcon } from "@/components/icons";
import { composeTailwindRenderProps } from "@/components/utils";

interface EmailInputProps extends InputProps {
  onClear?: () => void;
  showClearButton?: boolean;
}

export const EmailInput = React.forwardRef<HTMLInputElement, EmailInputProps>(
  function EmailInput({ onClear, showClearButton, ...inputProps }, ref) {
    return (
      <Group
        className={[
          "isolate",
          "grid",
          "grid-cols-[calc(theme(size.6)+16px)_1fr_calc(theme(size.6)+16px)]",
        ].join(" ")}
        data-ui="control"
      >
        <EmailIcon
          aria-label="Email"
          className="z-10 col-start-1 row-start-1 place-self-center text-text-tertiary"
        />

        <Input
          {...inputProps}
          className={composeTailwindRenderProps(inputProps.className, [
            "col-span-full",
            "row-start-1",
            "pl-10",
            showClearButton ? "pr-10" : "pr-4",
          ])}
          ref={ref}
          type="email"
        />

        {showClearButton && onClear && (
          <Button
            className="z-10 -col-end-1 row-start-1 place-self-center"
            isIconOnly
            onPress={onClear}
            size="sm"
            variant="plain"
          >
            <div className="flex items-center justify-center w-[26px] h-[26px] bg-bg-tertiary rounded-full hover:bg-bg-quaternary transition-colors">
              <XIcon
                aria-label="Clear email"
                className="w-[16px] h-[16px] text-text-tertiary scale-[0.80]"
                color="#667085"
              />
            </div>
          </Button>
        )}
      </Group>
    );
  },
);
